import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  constructor(public auth: AuthService,private router: Router) {}

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.auth.userProfile$.subscribe(
      profile => {
        if(profile!=null && profile[environment.roleClaim].length!=0){
          this.router.navigate(['/student-search']);    
        }  
      }
    );   
  }
}
